export enum DataCardButtonType {
  upload = 'upload',
  config = 'config',
}
